import { Type, type Static } from "@sinclair/typebox";
import { ProjectIdSchema, RoomIdSchema, UuidSchema } from "./identifiers.ts";
import { MatrixUserIdSchema } from "./registered-agent.ts";

export const PROJECT_MATRIX_ROOM_MARKER_KEY = "io.matrix_idp.project";

export const ProjectMatrixRoomEnsureInputSchema = Type.Object(
  { kind: Type.Literal("groupRoom") },
  { additionalProperties: false }
);
export type ProjectMatrixRoomEnsureInputV1 = Static<typeof ProjectMatrixRoomEnsureInputSchema>;

export const DirectChatPeerSchema = Type.Union([
  Type.Object(
    { kind: Type.Literal("human"), mxid: MatrixUserIdSchema },
    { additionalProperties: false }
  ),
  Type.Object({ kind: Type.Literal("agent"), agentId: UuidSchema }, { additionalProperties: false })
]);
export type DirectChatPeerV1 = Static<typeof DirectChatPeerSchema>;

export const DirectChatEnsureInputSchema = Type.Object(
  { peer: DirectChatPeerSchema },
  { additionalProperties: false }
);
export type DirectChatEnsureInputV1 = Static<typeof DirectChatEnsureInputSchema>;

export const ProjectMatrixRoomMarkerSchema = Type.Union([
  Type.Object(
    {
      version: Type.Literal(1),
      project_id: ProjectIdSchema,
      room_kind: Type.Literal("groupRoom"),
      initiator_mxid: MatrixUserIdSchema
    },
    { additionalProperties: false }
  ),
  Type.Object(
    {
      version: Type.Literal(1),
      project_id: ProjectIdSchema,
      room_kind: Type.Literal("directChat"),
      initiator_mxid: MatrixUserIdSchema,
      direct_peer_mxid: MatrixUserIdSchema
    },
    { additionalProperties: false }
  )
]);
export type ProjectMatrixRoomMarkerV1 = Static<typeof ProjectMatrixRoomMarkerSchema>;

export const ProjectMatrixRoomEnsureResultSchema = Type.Object(
  {
    projectId: ProjectIdSchema,
    roomId: RoomIdSchema,
    kind: Type.Literal("groupRoom")
  },
  { additionalProperties: false }
);
export type ProjectMatrixRoomEnsureResultV1 = Static<typeof ProjectMatrixRoomEnsureResultSchema>;

export const DirectChatEnsureResultSchema = Type.Object(
  {
    roomId: RoomIdSchema,
    directPeerMxid: MatrixUserIdSchema
  },
  { additionalProperties: false }
);
export type DirectChatEnsureResultV1 = Static<typeof DirectChatEnsureResultSchema>;
